import React from 'react';
import PropTypes from 'prop-types';
import { Popover, Menu } from "@blueprintjs/core";
import { Button } from 'components/buttons/Button';
import './dropdown.css';

var POPOVER_POSITIONS = {
    TOP: "top",
    TOP_LEFT: "top-start",
    TOP_RIGHT: "top-end",
    BOTTOM: "bottom",
    BOTTOM_LEFT: "bottom-start",
    BOTTOM_RIGHT: "bottom-end",
    LEFT: "left",
    LEFT_TOP: "left-start",
    LEFT_BOTTOM: "left-end",
    RIGHT: "right",
    RIGHT_TOP: "right-start",
    RIGHT_BOTTOM: "right-end",
    AUTO: "auto"
};

export function Dropdown(
    {
        id = null,
        intent = "",
        loading = false,
        disabled = false,
        icon = null,
        iconOnly = false,
        text = "",
        minimal = false,
        large = true,
        items = [],
        preamble = null,
        popoverUsePortal = true,
        onClick = () => { },
        showArrow = true,
        popoverPosition = "BOTTOM",
        isOpen = null,
        className,
        size
    }
) {
    function handleButtonClick() {
        if (onClick) {
            onClick();
        }
    }
    const menuItems = (
        <>
            {preamble && <div className='dropdown-preamble'>{preamble}</div>}
            <Menu>
                {items.map(item => (item))}
            </Menu>
        </>
    );
    let popoverPositionValue = POPOVER_POSITIONS[popoverPosition];

    return (
        <span className="dropdown-container">
            <Popover content={menuItems} placement={popoverPositionValue} isOpen={isOpen} >
                <Button
                    alignText="start"
                    rightIcon={showArrow ? "caret-down" : null}
                    className={className}
                    icon={icon}
                    loading={loading}
                    disabled={disabled}
                    minimal={minimal}
                    large={large}
                    intent={intent}
                    id={id}
                    text={text}
                    iconOnly={iconOnly}
                    onClick={handleButtonClick}
                    size={size}
                />
            </Popover>
        </span>
    );
}

Dropdown.propTypes = {
    id: PropTypes.string,
    intent: PropTypes.string,
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    iconOnly: PropTypes.bool,
    text: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    minimal: PropTypes.bool,
    large: PropTypes.bool,
    className: PropTypes.string,
    items: PropTypes.array.isRequired,
    preamble: PropTypes.object,
    popoverUsePortal: PropTypes.bool,
    showArrow: PropTypes.bool,
    popoverPosition: PropTypes.string,
    isOpen: PropTypes.bool,
};